
import React from 'react';

// form stuff
import TextField from 'material-ui/TextField';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import {observer } from 'mobx-react';


const inputStyle = {
	marginLeft: 30,
	flex:1
};

const doubleContainer = {
    display: 'flex',
    flexDirection: 'row wrap',
    width: '100%',
}
const paperStyle = {
	boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
}


@observer
export default class UserDetails extends React.Component {

	onChange(){
		console.log("change")
	}

	componentDidMount(){

		window.analytics.page('Build');
	}
	
	render(){
		// const userDetails = this.props.userDetails
		const {firstName,lastName,email,nickname} = this.props.userDetails
		return (
			<div style={this.props.style}>
			   <Paper zDepth={2}  style={paperStyle}>
			   	<div style={doubleContainer}>
			   		<TextField hintText="First name" disabled value={firstName} style={inputStyle} onChange={this.onChange} underlineShow={false} />
			   		<TextField hintText="Last name" disabled value={lastName} style={inputStyle} onChange={this.onChange} underlineShow={false} />
			   	</div>			    
			    <Divider />
			    <div style={doubleContainer}>
			    	<TextField hintText="Email address" disabled value={email} style={inputStyle} onChange={this.onChange} underlineShow={false} />
			    	<TextField hintText="Nickname" disabled value={nickname} style={inputStyle} onChange={this.onChange} underlineShow={false} />
			    </div>	
			    <Divider />	 						   
			  </Paper>
			</div>			
		);
	}
   
}


// WEBPACK FOOTER //
// ./src/js/components/UserDetails.js